import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { RegistroNegocioPendienteModel } from './RegistroNegocioPendiente.model'
import { DescargarIntefazNegocio } from './RegistroNegocioPendiente.model'
import { of } from 'rxjs/observable/of';
import { DatePipe } from '@angular/common';
import { Http, ResponseContentType } from '@angular/http';


@Component({
	selector: 'decargarInterfaz',
	templateUrl: './DescargarInterfaz.component.html',
	styleUrls: ['../../../../styles.css']

})
export class DescargarInterfazComponent {

	public fecha: string;
	public user:String;
	myControl = new FormControl();
	public form: FormGroup;
	public formErrors: any;
	public cargando: boolean = false;

	public displayedColumns = ['Negocio', 'Fecha', 'Descargar'];
	public dataDataBase: RegistroDatabaseInterfaz;
	public dataSource: ExampleDataSource;
	public render: boolean = false;

	public ocultar: boolean= false;
	public mensaje: string="";

	private formulario: any;
	private http: Http


	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar) {

		this.fecha = "";
		this.user = "";

		this.formErrors = {

			fecha: {},

		};
		this.snackBar.dismiss();
	}

	ngOnInit() {

		this.form = this.formBuilder.group({
			fecha: ['', Validators.required]
		});

		this.form.valueChanges.subscribe(() => {
			for (const field in this.formErrors) {
				if (!this.formErrors.hasOwnProperty(field)) {
					continue;
				}

				// Clear previous errors
				this.formErrors[field] = {};

				// Get the control
				const control = this.form.get(field);

				if (control && control.dirty && !control.valid) {
					this.formErrors[field] = control.errors;
				}
			}
		});
	}

public descargarInterfaz(archivo:string){

	this.cargando = true;

	const formModel = this.formulario;
	var info: string;

	this._serviciosGenerales.post('Descargar/DescargarInterfaz/'+archivo, formModel).subscribe(res => {
	
			info = 'data:text/plain;base64,' + res.info;
			var dlnk = document.getElementById('dwnldLnk');
			dlnk.setAttribute('download', archivo);
			dlnk['href'] = info;
			dlnk.click();
			this.cargando = false;
			
	}, error => {
		console.log(error, '');
		
	})

}


	public consultarInterfaz() {

		const formModel = this.formulario;
		this.render = false;
		this.cargando = true;	

		if(this.fecha === ''){
			this.openSnackBarEspecial("Ingrese una fecha", "X");
		    this.cargando = false;
			return;
		}

		const dateSendingToServer = new DatePipe('es-US').transform(this.fecha, 'dd-MM-yyyy')

		this._serviciosGenerales.post('ListarInformacion/getInterfaces/'+dateSendingToServer, formModel).subscribe(
			result => {
				this.cargando = false;
				if (result.length == 0) {
					this.openSnackBarEspecial("No se encontraron registros", "X");
					return;
				}
		
				console.log(result);
				this.snackBar.dismiss(); 
				this.dataDataBase = new RegistroDatabaseInterfaz();

				for (let x of result) {
					this.dataDataBase.addRegistro(new DescargarIntefazNegocio(x.nombreArchivo, x.rutaArchivo, new Date(x.fecha)));
				}

				this.dataSource = new ExampleDataSource(this.dataDataBase);
				this.render = true;

			}, error => {
				this.cargando = false;
				this.openSnackBarEspecial("Ocurrió un error al momento de consultar la información", "X");
			}
		)

	}
	
	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});

	}
	openSnackBarEspecial(message: string, action: string) {
        let snackBarRef =  this.snackBar.open(message, action);
 
        snackBarRef.onAction().subscribe(() => {
           
            this.ocultar = false;
            this.mensaje = "";
        });
        
        let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;        
        
        if (shand.length != 0) {
                for (let i=0;i<shand.length;i++){
                shand[i].style.backgroundColor = "rgb(255 204 214)";
                }
            }
    }

}

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

export class RegistroDatabaseInterfaz {

	dataChange: BehaviorSubject<DescargarIntefazNegocio[]> = new BehaviorSubject<DescargarIntefazNegocio[]>([]);

	get data(): DescargarIntefazNegocio[] {
		return this.dataChange.value;
	}

	addRegistro(log: DescargarIntefazNegocio) {
		const copiedData = this.data.slice();
		copiedData.push(log);
		this.dataChange.next(copiedData);
	}

}

export class ExampleDataSource extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string {
		return this._filterChange.value;
	}

	set filter(filter: string) {
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: RegistroDatabaseInterfaz) {
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<DescargarIntefazNegocio[]> {
		const displayDataChanges = [
			this._exampleDatabase.dataChange,
			this._filterChange
		];

		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: DescargarIntefazNegocio) => {
				let searchStr = (item.nombre).toLowerCase();
				return searchStr.indexOf(this.filter.toLowerCase()) != -1;
			});
		});
	}

	disconnect() {
	}
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/DescargarInterfaz/DesacargarInterfaz.component.ts